import { Injectable, DOCUMENT, inject } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class OperatingSystemService {
  protected _document = inject<Document>(DOCUMENT)

  /** The current OS */
  private _currentOS: string = ''

  /** The window object */
  private _window: Window

  constructor() {
    const _document = this._document
    this._window = _document.defaultView as Window
    this.setCurrentOS()
  }

  /**
   * Will state if the user is currently on mac os
   */
  public isMacOS(): boolean {
    return this._currentOS.includes('Mac')
  }

  /**
   * Will set the current os through the navigator attribute of the window
   * @private
   */
  private setCurrentOS(): void {
    this._currentOS = this._window.navigator.platform
  }
}
